import React from "react";
import styles from "./ParticipationProcess.module.css";
import {
  FaUsers,
  FaGraduationCap,
  FaMapMarkerAlt,
  FaPeopleArrows,
  FaMousePointer,
  FaLink,
} from "react-icons/fa";
import scanner from "../../../assets/images/robotics/qrRegular.png";
import { FaComputerMouse } from "react-icons/fa6";
const ParticipationProcess = () => {
  const stats = [
    { icon: <FaPeopleArrows />, value: "250+", label: "Teams" },
    { icon: <FaGraduationCap />, value: "3-12", label: "Grade" },
    { icon: <FaUsers />, value: "2000+", label: "Audience" },
    { icon: <FaMapMarkerAlt />, value: "India", label: "" },
  ];

  const directEntrySteps = [
    { label: "Learn about IRL - Regular Category" },
    { label: "Register for IRL Regular Category" },
    { label: "Decide Your Team or Solo" },
    { label: "Submit Your Idea Online" },
    { label: "Get... Set... Go...IRL" },
  ];

  return (
    <div className={styles.participationProcess}>
      <h2 className={styles.title}>India Robotics League</h2>
      <div className={styles.stats}>
        {stats.map((stat, index) => (
          <div key={index} className={styles.statItem}>
            <div className={styles.statIcon}>{stat.icon}</div>
            <div className={styles.statValue}>{stat.value}</div>
            <div className={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>

      <div className={styles.timelineContainer}>
        <div className={styles.timelineSection}>
          <h3 className={styles.timelineHeader}>Registration Process</h3>
          <div className={styles.timeline}>
            {directEntrySteps.map((step, index) => (
              <div key={index} className={styles.timelineStep}>
                <div className={styles.stepNumber}>{index + 1}</div>
                <div className={styles.timelineContent}>
                  <div className={styles.stepLabel}>{step.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.register}>
        <h3>Register Here</h3>
        <div className={styles.registrations}>
          <div className={styles.scanner}>
            <img src={scanner} alt="Scanner" />
          </div>
          <div className={styles.buttons}>
            <button
              className={styles.primary}
              onClick={() =>
                window.open(
                  "https://docs.google.com/forms/d/e/1FAIpQLSeTW2dNVY63d2DGJ5KWnRwWiOpdx0wzVzqLV90eAnRYIlxVvQ/viewform",
                  "_blank"
                )
              }
            >
              Click here to register <FaLink className={styles.icon} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipationProcess;
